document.addEventListener('DOMContentLoaded', function () {

  var basePrice = null;
  var baseComparePrice = null;
  var extras = {
    drawer: 0,
    mattress: 0,
    build: 0,
    recycle: 0
  };
  var ignoreNextMutation = false;
  var priceObserver = null;

  var ADDON_VARIANTS = {
    '46917169840277': 'build',
    '46917175246997': 'recycle'
  };

  function parsePrice(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/[^\d.]/g, '');
    return parseFloat(cleaned) || 0;
  }

  function formatPrice(amount) {
    return '£' + amount.toFixed(2);
  }

  function getDrawerExtra(card) {
    if (!card) return 0;
    var priceEl = card.querySelector('.drawer-price');
    if (!priceEl) return 0;
    var text = priceEl.textContent.trim();
    if (text === 'Included' || text === 'Free' || text === '') return 0;
    return parsePrice(text);
  }

  function getActiveDrawerCard() {
    return document.querySelector('.drawer-card.active');
  }

  function getPriceElement() {
    var el = document.querySelector('product-price .price');
    if (el) return el;
    el = document.querySelector('[ref="priceContainer"] .price');
    if (el) return el;
    el = document.querySelector('.price');
    return el;
  }

  function getCompareElement() {
    var el = document.querySelector('product-price .compare-at-price');
    if (el) return el;
    el = document.querySelector('[ref="priceContainer"] .compare-at-price');
    if (el) return el;
    el = document.querySelector('.compare-at-price');
    return el;
  }

  function getTotalExtras() {
    return extras.drawer + extras.mattress + extras.build + extras.recycle;
  }

  function updatePriceDisplay() {
    var priceEl = getPriceElement();
    if (!priceEl) return;

    var displayedPrice = parsePrice(priceEl.textContent);
    if (displayedPrice === 0) return;

    var compareEl = getCompareElement();
    var totalExtras = getTotalExtras();

    if (basePrice === null) {
      basePrice = displayedPrice - totalExtras;
      if (basePrice < 0) basePrice = displayedPrice;
    }

    // Capture the bed's original "was" price the first time we see a
    // compare-at element. We bump it in step with the sale price when addons
    // are added so the "Save £X" badge (driven by compare > sale) stays
    // accurate instead of disappearing once the total exceeds the bed's RRP.
    if (compareEl && baseComparePrice === null) {
      var displayedCompare = parsePrice(compareEl.textContent);
      if (displayedCompare > 0) {
        baseComparePrice = displayedCompare - totalExtras;
        if (baseComparePrice < 0) baseComparePrice = displayedCompare;
      }
    }

    var newTotal = basePrice + totalExtras;

    var changed = parsePrice(priceEl.textContent) !== newTotal;
    var newCompareTotal = null;
    if (compareEl && baseComparePrice !== null) {
      newCompareTotal = baseComparePrice + totalExtras;
      if (parsePrice(compareEl.textContent) !== newCompareTotal) changed = true;
    }

    if (changed) {
      ignoreNextMutation = true;
      priceEl.textContent = formatPrice(newTotal);
      if (compareEl && newCompareTotal !== null) {
        compareEl.textContent = formatPrice(newCompareTotal);
      }
    }
  }

  function handleDrawerClick() {
    setTimeout(function () {
      var activeCard = getActiveDrawerCard();
      extras.drawer = getDrawerExtra(activeCard);
      updatePriceDisplay();
    }, 100);
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.drawer-card');
    if (card) {
      handleDrawerClick();
    }
  });

  function setupAddonObservers() {
    var forms = document.querySelectorAll('.addon-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var btn = form.querySelector('.addon-btn');
      if (!btn) return;

      var variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;
      var variantId = variantIdInput.value;
      var key = ADDON_VARIANTS[variantId];
      if (!key) return;

      var card = form.closest('.addon-card');
      var priceEl = card ? card.querySelector('.addon-price') : null;
      var price = priceEl ? parsePrice(priceEl.textContent) : 0;

      if (btn.classList.contains('added')) extras[key] = price;

      var observer = new MutationObserver(function () {
        if (btn.classList.contains('added')) {
          extras[key] = price;
        } else {
          extras[key] = 0;
        }
        updatePriceDisplay();
      });
      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function setupMattressObservers() {
    var selectedEl = document.getElementById('mattress-addon-selected');
    if (!selectedEl) return;

    function update() {
      var isVisible = selectedEl.style.display !== 'none' &&
        getComputedStyle(selectedEl).display !== 'none';

      if (isVisible) {
        var priceEl = document.getElementById('selected-mattress-price');
        if (priceEl) extras.mattress = parsePrice(priceEl.textContent);
      } else {
        extras.mattress = 0;
      }
      updatePriceDisplay();
    }

    var styleObserver = new MutationObserver(update);
    styleObserver.observe(selectedEl, { attributes: true, attributeFilter: ['style'] });

    var mattressPriceEl = document.getElementById('selected-mattress-price');
    if (mattressPriceEl) {
      var priceObserverInner = new MutationObserver(update);
      priceObserverInner.observe(mattressPriceEl, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function attachPriceObserver() {
    if (priceObserver) {
      priceObserver.disconnect();
      priceObserver = null;
    }

    var priceContainer = document.querySelector('[ref="priceContainer"]');
    if (!priceContainer) return;

    priceObserver = new MutationObserver(function () {
      if (ignoreNextMutation) {
        ignoreNextMutation = false;
        return;
      }
      var priceEl = getPriceElement();
      if (!priceEl) return;
      var displayedPrice = parsePrice(priceEl.textContent);
      if (displayedPrice === 0) return;
      basePrice = displayedPrice;
      var compareEl = getCompareElement();
      baseComparePrice = compareEl ? parsePrice(compareEl.textContent) : null;
      updatePriceDisplay();
    });
    priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
  }

  setupAddonObservers();
  setupMattressObservers();
  attachPriceObserver();

  var picker = document.querySelector('variant-picker');
  if (picker) {
    picker.addEventListener('change', function () {
      basePrice = null;
      baseComparePrice = null;
      extras.drawer = 0;
      setTimeout(updatePriceDisplay, 500);
    });
  }

  // Shopify's product-price.js replaces the entire [ref="priceContainer"] element
  // on variant change, which detaches the MutationObserver above. Listen for the
  // variant:update event so we can re-attach to the new element and re-apply extras.
  document.addEventListener('variant:update', function () {
    basePrice = null;
    baseComparePrice = null;
    extras.drawer = 0;
    setTimeout(function () {
      attachPriceObserver();
      var priceEl = getPriceElement();
      if (priceEl) {
        basePrice = parsePrice(priceEl.textContent);
      }
      var compareEl = getCompareElement();
      baseComparePrice = compareEl ? parsePrice(compareEl.textContent) : null;
      updatePriceDisplay();
    }, 150);
  });

  setTimeout(updatePriceDisplay, 800);
});
